/**
 * Model definition for Meta
 */
import { Author } from '../author';
import { File } from '../file';
import { Publisher } from '../publisher';

export interface InternArticleMeta {
  __component: 'intern.meta';
  id: string;
  headline?: string;
  description?: string;
  media_1x1: File;
  author?: Author;
  publisher?: Publisher;
  articlePublishedFirstAt?: string;
  articlePublishedAt?: string;
}

export function isInternArticleMeta(obj: { __component?: string }): obj is InternArticleMeta {
  return obj.__component === 'intern.article-meta';
}
